<template>
  <div id="app">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
  </div>
</template>

<script>
export default {
    name: 'App'
};
</script>

<style>
@import './common/css/common.scss';
/*网站置灰*/
/* body, html{
} */

body, ul, li, h1, h2, h3, h4, h5, h6, p, form, dl, dt, dd, div {
    margin: 0px;
    padding: 0px;
}
ul { list-style: none; }
img { border-style: none; }

#app {
  font-family: 'PingFangSC-Regular', 'helvetica neue', 'PingFang SC', 'microsoft yahei', arial, 'hiragino sans gb', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
</style>



// WEBPACK FOOTER //
// src/App.vue